import { AfterViewInit, Component } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-domain-specific-dictionaries',
  templateUrl: './domain-specific-dictionaries.component.html',
  styleUrls: ['./domain-specific-dictionaries.component.scss']
})
export class DomainSpecificDictionariesComponent implements AfterViewInit {

  activeSlide = 0;

  slides = [
    'Medicine',
    'Biology',
    'Physics',
    'Social Science',
    'Engineering',
    'Chemistry',
    'Geology',
    'Computer Science',
    'Economics'
  ];

  constructor() {}

  ngAfterViewInit(): void {

    $('#dictionaries-carousel').on('slid.bs.carousel', (event: any) => {
  
      this.activeSlide = event.to;
  
      const announcer = document.getElementById('carousel-announcer');
  
      if (announcer) {
  
        // Clear first so screen readers announce repeated changes
        announcer.textContent = '';
  
        setTimeout(() => {
          announcer.textContent =
            `Slide ${this.activeSlide + 1} of ${this.carouselData.slides.length}. ${this.carouselData.slides[this.activeSlide].title}`;
        }, 100);
  
      }
  
    });
  
  }

  carouselData = {
    id: 'dictionaries-carousel',
    label: 'Built-in Domain-Specific Dictionaries Carousel',
  
    slides: [
      {
        title: 'Medicine',
        html: `
          The physician recommended a thorough examination of the
          <span class="wrongText">gastrointestial</span>
          <span class="rightText">gastrointestinal</span>
          tract.
        `
      },
  
      {
        title: 'Biology',
        html: `
          The most abundant
          <span class="wrongText">phylla</span>
          <span class="rightText">phyla</span>
          were
          <span class="wrongText d-inline">Pseudomonodota</span>
          <span class="rightText d-inline">Pseudomonadota</span>
          (22%) and
          <span class="wrongText d-inline">Bacterodota</span>
          <span class="rightText d-inline">Bacteroidota</span>.
        `
      },
  
      {
        title: 'Physics',
        html: `
          Strength of IMF-sensitive stellar
          <span class="wrongText d-inline">absorbtion</span>
          <span class="rightText d-inline">absorption</span>
          features is regulated by the ratio of dwarf to giant stars.
        `
      },
  
      {
        title: 'Social sciences',
        html: `
          The elements of protest masculinity discount the
          <span class="wrongText d-inline">embodimint</span>
          <span class="rightText d-inline">embodiment</span>
          of pure inclusive masculinity.
        `
      },
  
      {
        title: 'Engineering',
        html: `
          We presented a novel approach to derive
          <span class="wrongText d-inline">nonliner</span>
          <span class="rightText d-inline">nonlinear</span>
          filters from schematics of audio
          <span class="wrongText d-inline">circits</span>
          <span class="rightText themeColor d-inline">circuits</span>.
        `
      },
  
      {
        title: 'Chemistry',
        html: `
          Adjunct therapy with
          <span class="wrongText d-inline">hyaluranic</span>
          <span class="rightText d-inline">hyaluronic</span>
          acid provides a long lasting therapeutic effect.
        `
      },
  
      {
        title: 'Geology',
        html: `
          The low contents of incompatible elements indicate negligible involvement of
          <span class="wrongText d-inline">terrigeneous</span>
          <span class="rightText d-inline">terrigenous</span>
          clastics during the deposition.
        `
      },
  
      {
        title: 'Computer science',
        html: `
          A new deep
          <span class="wrongText d-inline">regulization</span>
          <span class="rightText d-inline">regularization</span>
          mechanism allows the learning model to unlearn biased information.
        `
      },
  
      {
        title: 'Economics',
        html: `
          Use of monetary
          <span class="wrongText d-inline">agregates</span>
          <span class="rightText d-inline">aggregates</span>
          as indicators of policy is controversial because of many factors.
        `
      }
    ]
  };
}